import { Dialog } from "@components/ngg";
import { XIcon } from "@ngg/icons";
import type { Dispatch, SetStateAction } from "react";
import type { Dictionary } from "types/common";

const ToolTip = ({
  open,
  setOpen,
  dictionary,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  dictionary: Dictionary;
}) => (
  <>
    <button
      type="button"
      tabIndex={-1}
      onClick={() => setOpen(true)}
      className="ml-4 text-xs text-grey-300 hover:underline"
    >
      {dictionary?.whatIsAStrongPassword}
    </button>
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      title={dictionary?.whatIsAStrongPassword}
      subtitle={dictionary?.whatIsAStrongPasswordTooltip}
      alignment="top"
      classNames={{
        backdrop: "bg-black/70",
        panel: "max-w-[420] w-full pt-12 pb-10 px-6 text-left mt-1/4",
        panelHeader: "px-0",
        title: "text-lg font-bold",
        subtitle: "mt-4 text-sm",
      }}
    >
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="absolute right-3 top-3 text-base"
      >
        <XIcon />
      </button>
    </Dialog>
  </>
);

export default ToolTip;
